import React from 'react'

export default () => <div id="footer" />
